export enum CoercionType {
    Text = 0,
    Html = 3,
}
export interface AppendOnSend {
    txt: string;
    typ: CoercionType;
    id: string;
}

export enum ComposeType {
    Unknown,
    New,
    Reply,
    Forward,
}

export interface SubjectViewState {
    selectionStart: number;
    selectionEnd: number;
}

export interface AddinViewState {
    appendOnSend?: AppendOnSend[];
    draftComposeType?: ComposeType;
    subject: SubjectViewState;
}
